export enum AuthStateEnum {
  UNKNOWN = 'UNKNOWN',
  LOADING = 'LOADING',
  ANONYMOUS = 'ANONYMOUS',
  AUTHORIZED = 'AUTHORIZED',
}
